import { styled } from '@material-ui/core/styles'
import { FormControl } from '@material-ui/core'

export const SessionFormControl = styled(FormControl)({
  margin: '1rem auto',
  width: '100%'
})
